import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import LoadingLoader from '../Loader/Loader'
export default class componentName extends Component {
  constructor(props) {
    super(props)
    this.state = {
      newSchedule: [],
      loading: true
    }
  }

  data = [
    { name: 'Dentist', description: 'Click Here To book your appointment with a Dentist. You can also book your appointment with a Dentist by calling at 042-32591427 or 0311-1222398. There are no extra charges for booking through Marham.', type: 'Teeth cleen', key: 1 },
    { name: 'Car Wash', description: 'A car wash (also written as "carwash"[1]) or auto wash is a facility used to clean the exterior[2] and, in some cases, the interior of motor vehicles. Car washes can be self-serve, fully automated, or full-service with attendants who wash the vehicle.', type: 'Clean Car', key: 2 },
    { name: 'Dentist', description: 'Click Here To book your appointment with a Dentist. You can also book your appointment with a Dentist by calling at 042-32591427 or 0311-1222398. There are no extra charges for booking through Marham.', type: 'Teeth cleen', key: 3 },
  ]

  componentDidMount() {
    this.getNewSchedule()
  }

  getNewSchedule = () => {
    let body = {
      timeStart: "1534330562000",
      state: "0"
    }
    this.props.apiManager.makeCall('get_schedules', body, res => {
      if (res) {
        this.setState({
          newSchedule: res.result.docs,
          loading: false
        })
      }
      else {
      }
    })
  }

  emptyCart = () => {
    return (
      <div style={{ minHeight: '60vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <section className="cart-section section-b-space" style={{ marginTop: 50, }}>
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div >
                  <div className="col-sm-12 empty-cart-cls text-center">
                    <img src={`${process.env.PUBLIC_URL}/assets/images/icon-empty-cart.png`} className="img-fluid mb-4" alt="" />
                    <h3>
                      <strong>you have no schedule yet</strong>
                    </h3>
                    <h4>Explore more shortlist some items.</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }

  render() {
    if (this.state.loading) return <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', }}>
      <LoadingLoader visibel={this.state.loading} />
    </div>

    return (
      <div className="col-xl-12 col-lg-12 col-md-12 order-sec">
        {
          this.state.newSchedule.length === 0 ? this.emptyCart() :
            this.state.newSchedule.map((item, i) => {
              const data = {
                pathname: `/bookschedule/${item._id}`,
                state: {
                  img: item.productImage,
                  name: item.productName,
                  price: item.priceAfterDiscount,
                  amountDue: item.amountDueAtVenue
                }
              }
              return (
                <div className="row blog-media" style={{ marginBottom: 20, boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)', padding: '10px 10px 10px 0', }}>
                  <div className="col-xl-5">
                    <div className="blog-left">
                      <Link to={`${process.env.PUBLIC_URL}/product/${item.productId}`} >
                        <img src={item.productImage} style={{ maxHeight: '200px' }} alt="" height='160px' width='100%' />
                      </Link>
                    </div>
                  </div>
                  <div className="col-xl-7" style={{ marginTop: 5 }}>
                    <div className="blog-right">
                      <div>
                        <h4>{item.productName}</h4>
                        <p>{item.description}</p>

                      </div>
                      <ul className="post-social" style={{ display: 'flex', flexDirection: 'column' }}>
                        <ul className="post-social" style={{ display: 'flex', flexDirection: 'column' }}>
                          <li><i style={{ margin: 5, fontWeight: '700' }}>Total Amount:</i>RM {item.priceAfterDiscount}</li>
                          <li><i style={{ margin: 5, fontWeight: '700' }}>Paid Amount: </i>RM {item.paidAmount}</li>
                          <li><i style={{ margin: 6, fontWeight: '700' }}> Amount Due:  </i> RM {item.amountDueAtVenue}</li>
                        </ul>
                        <ul className="post-social" style={{ display: 'flex', flexDirection: 'column' }}>
                          <li><i style={{ margin: 5 }} className="fa fa-map-marker"></i>{item.originAddress.address},{item.originAddress.cityName},{item.originAddress.provinceName}</li>
                        </ul>
                      </ul>

                    </div>
                    <div style={{ display: "flex", alignItems: 'center', bottom: 0, justifyContent: 'flex-end', right: 0, cursor: 'pointer' }} onClick={() => this.props.history.push(data)}>
                      <h6 style={{ alignSelf: 'center', alignItems: 'center', paddingTop: 7, marginRight: 5 }}>
                        Book Now
                                        </h6>
                      <FontAwesomeIcon icon={faChevronRight} size="1x" color='grey' />
                    </div>
                  </div>
                </div>
              )
            })}
      </div>
    );
  }
}
